import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { useOrganizationalStructureDetailsDispatch } from './organizational-structure-details-context';
import { ACTION_TYPES } from './organizational-structure-details-reducer';

export const useOrganizationalStructureDetailsController = () => {
  const dispatch = useOrganizationalStructureDetailsDispatch();

  const onInit = useCallback(async (id: string) => {
    await getOrganizationalStructureDetails(id);
  }, []);

  const getOrganizationalStructureDetails = useCallback(async (id: string) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      
      const response = await MunicipalPortalAAppService.getGovernamentalStrucutre(parseInt(id));
      
      dispatch({ type: ACTION_TYPES.setOrganizationalStructureDetails, payload: response });
    } catch (error) {
      console.error('Error loading organizational structure details:', error);
      dispatch({ type: ACTION_TYPES.setOrganizationalStructureDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  return {
    onInit,
    getOrganizationalStructureDetails,
  };
};